

import React from "react";
import { FormControl, Select, MenuItem, Button } from "@mui/material";

const Filters = ({
  filterOptions = { parentDomains: [], domains: [], subDomains: [], products: [] },
  parentDomain,
  domain,
  subDomain,
  product,
  onParentDomainChange,
  onDomainChange,
  onSubDomainChange,
  onProductChange,
  onReset,
}) => {
  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: 200,
        overflowY: "auto",
      },
    },
  };

  const getDisplayValue = (value, defaultLabel) =>
    value === "" || value === undefined ? defaultLabel : value;

  return (
    <div className="dash-filters">
      <div className="dash-filter-group">
        <label className="dash-filter-label">Parent Domain</label>
        <FormControl fullWidth>
          <Select
            value={parentDomain || ""}
            onChange={onParentDomainChange}
            displayEmpty
            className="dash-select"
            MenuProps={menuProps}
            renderValue={(selected) =>
              selected ? selected : "All Parent Domains"
            }
          >
            <MenuItem value="">All Parent Domains</MenuItem>
            {(filterOptions.parentDomains || []).map((pd) => (
              <MenuItem key={pd.parent_domain_id} value={pd.parent_domain}>
                {pd.parent_domain}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className="dash-filter-group">
        <label className="dash-filter-label">Domains</label>
        <FormControl fullWidth>
          <Select
            value={domain || ""}
            onChange={onDomainChange}
            displayEmpty
            className="dash-select"
            MenuProps={menuProps}
            renderValue={(selected) =>
              selected ? selected : "All Domains"
            }
          >
            <MenuItem value="">All Domains</MenuItem>
            {(filterOptions.domains || []).map((d) => (
              <MenuItem key={d.domain_id} value={d.domain}>
                {d.domain}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className="dash-filter-group">
        <label className="dash-filter-label">Sub Domains</label>
        <FormControl fullWidth>
          <Select
            value={subDomain || ""}
            onChange={onSubDomainChange}
            displayEmpty
            className="dash-select"
            MenuProps={menuProps}
            renderValue={(selected) =>
              selected ? selected : "All Sub Domains"
            }
          >
            <MenuItem value="">All Sub Domains</MenuItem>
            {(filterOptions.subDomains || []).map((sd) => (
              <MenuItem key={sd.sub_domain_id} value={sd.sub_domain}>
                {sd.sub_domain}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className="dash-filter-group">
        <label className="dash-filter-label">Products</label>
        <FormControl fullWidth>
          <Select
            value={product || ""}
            onChange={onProductChange}
            displayEmpty
            className="dash-select"
            MenuProps={menuProps}
            renderValue={(selected) =>
              selected ? selected : "All Products"
            }
          >
            <MenuItem value="">All Products</MenuItem>
            {(filterOptions.products || []).map((p, i) => (
              <MenuItem key={i} value={p}>
                {p}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className="dash-filter-group" style={{ marginTop: "25px" }}>
        <Button
          onClick={onReset}
          variant="outlined"
          sx={{
            textTransform: "none",
            borderColor: "#E8E8EB",
            color: "#747474",
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
            height: "38px",
            backgroundColor: "white",
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default Filters;


